import React, { useEffect } from 'react';
import { Message } from '@meitu/saas-ui';
import type { Editor } from '@meitu/saas-editor-core';
import { WatermarkLayer } from '@meitu/saas-editor-core/es/layers/watermark-layer';
import { WATERMARK_TYPE } from '@meitu/saas-editor-core/es/version-types';
import { useLocaleStore } from '@/i18n';

type AddWatermarkProps = {
    editor: Editor;
    url: string;
    setUrl: Function;
};
const AddWatermark: React.FC<AddWatermarkProps> = React.memo(({ editor, url, setUrl }) => {
    const stageSize = editor.stage.getActiveSize();

    const { $t } = useLocaleStore();

    useEffect(() => {
        const fn = async () => {
            editor.tip.showMask({
                loading: true,
                background: true,
            });
            await editor
                .getInstance(WatermarkLayer)
                .addWatermarkLayer(WATERMARK_TYPE.IMG, stageSize, url, undefined, undefined, true);
            editor.tip.hideMask();
            Message.success($t((v) => v.collapse.watermarkCollapse.addSuccessText));
            setUrl('');
        };
        url && fn();
    }, [url]);
    return null;
});

export default AddWatermark;
